import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import CenterModal from '../CenterModal';
import Button from '../Button';
import './DeleteModal.scss';

interface DeleteModalProps {
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  itemName?: string;
  infoBoxText?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  onClose,
  onConfirm,
  title = 'Delete banner',
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  loading = false,
  itemName,
  infoBoxText,
}) => {
  const defaultMessage = itemName
    ? `Are you sure you want to delete this ${itemName}? This action cannot be undone.`
    : 'Are you sure you want to delete this banner? This action cannot be undone.';

  const footer = (
    <div className="delete-modal__footer">
      <Button
        theme="secondary"
        onClick={onClose}
        disabled={loading}
        className="delete-modal__footer-button delete-modal__footer-button--cancel"
      >
        {cancelText}
      </Button>
      <Button
        theme="danger"
        onClick={onConfirm}
        loading={loading}
        className="delete-modal__footer-button"
      >
        {confirmText}
      </Button>
    </div>
  );

  return (
    <CenterModal
      open={true}
      onClose={onClose}
      title={''}
      width={400}
      footer={footer}
      closable={true}
      maskClosable={!loading}
      className="delete-modal"
    >
      <div className="delete-modal__content">
        {/* Background pattern */}
        <div className="delete-modal__background-pattern" />

        <div className="delete-modal__icon-container">
          <svg
            className="delete-modal__icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M3 6H5H21" />
            <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" />
          </svg>
        </div>

        <h3 className="delete-modal__title">{title}</h3>

        <p className="delete-modal__message">{message || defaultMessage}</p>

        {infoBoxText && (
          <div className="delete-modal__info-box">
            <ExclamationCircleOutlined className="delete-modal__info-box-icon" />
            <span className="delete-modal__info-box-text">{infoBoxText}</span>
          </div>
        )}
      </div>
    </CenterModal>
  );
};

export default DeleteModal;

